<div style="clear:both;width:100%;">
    <div #editor></div>
</div>